import * as React from "react";

const TechnicalIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
                d="M11.8755 2.85642C11.8075 2.57306 11.4478 2.47837 11.2418 2.68443L9.44766 4.47881L7.5 4.4788V2.53115L9.29414 0.736774C9.50018 0.530781 9.40547 0.170992 9.1222 0.103024C8.56697 -0.0304061 7.9658 -0.040203 7.34283 0.108845C5.90259 0.453377 4.77877 1.67681 4.54908 3.13931C4.42711 3.74704 4.4857 4.35407 4.66852 4.90251L0.494297 9.07673C-0.164766 9.73579 -0.164766 10.8038 0.494297 11.4627C0.802734 11.7931 1.23398 11.9783 1.64508 11.9783C2.05617 11.9783 2.50852 11.8135 2.83828 11.484L7.0125 7.30978C7.56234 7.49109 8.1682 7.54978 8.79773 7.4505C10.2605 7.21987 11.4837 6.09581 11.8282 4.65675C12.0185 4.01189 12.0091 3.41189 11.8755 2.85642ZM1.85367 10.6658C1.54313 10.6658 1.29117 10.4138 1.29117 10.1033C1.29117 9.79251 1.54313 9.54079 1.85367 9.54079C2.16422 9.54079 2.41617 9.79251 2.41617 10.1033C2.41617 10.415 2.16422 10.6658 1.85367 10.6658Z"
                fill="#636161"
            />
        </svg>
    );
};

export default React.memo(TechnicalIcon);
